<template>
    <div class="asset-currency-chart" ref="currencyChart" id="currencyChart"></div>
</template>

<script>
/* eslint-disable */
import { mapState } from 'vuex'

export default {
    data() {
        return {
            data: {}
        }
    },
    mounted() {
        // console.log(this.assetChartData)
    },
    computed: {
        ...mapState([
            'token',
            'assetChartData'
        ])
    },
    methods: {
        // 初始化图表
        initAssetsChart(currency, myChart, assetChartNode) {
            var node = this.$refs.currencyChart;
            myChart.hideLoading();
            myChart.clear();
            var y_data = this.assetChartData['equity_rate'][currency];
            var y_value = this.assetChartData['equity'][currency];
            var y_data_1 = this.assetChartData['equity_rate']['USDT'];
            var y_value_1 = this.assetChartData['equity']['USDT'];
            var x_data = this.assetChartData['dateTime'];

            var option = {
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross'
                    },
                    position: [0, 0],
                    formatter: function (param) {
                        var showHtml = '' + param[0].axisValue + '<br>';
                        for (var i=0; i<param.length; i++) {
                            var paramObj = param[i];
                            var currency_name = paramObj.seriesName;
                            var value = paramObj.value;
                            if (currency_name == 'USDT') {
                                var currency_num = y_value_1[paramObj.dataIndex];
                            } else {
                                var currency_num = y_value[paramObj.dataIndex];
                            }
                            showHtml += paramObj.marker +  currency_name + ': '+ currency_num + '<br>'; 
                        }
                        return showHtml;
                    }
                },
                grid:[{
                    left: '3%',
                    top: '5%',
                    height: '75%'
                }],
                color: ['red', 'rgba(34, 166, 148)'],
                legend: {
                    data: [currency, 'USDT'],
                    textStyle: {
                        color: '#A7A7A7'
                    }
                },
                dataZoom: [{
                    show: true,
                    realtime: true,
                    start: 0,
                    end: 100
                },
                {
                    type: 'inside',
                    start: 70,
                    end: 100,
                    height: 20
                }],
                xAxis: [
                    {
                        type : 'category',
                        boundaryGap : false,
                        data : x_data,
                        axisLabel: {
                            textStyle: {
                                fontSize: 10
                            },
                        },
                        axisTick: {
                            show: false,
                            interval: 2,
                            length: 10
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#A7A7A7'
                            }
                        },
                    }
                ],
                yAxis: [
                    {
                        type : 'value',
                        position: 'right',
                        axisLabel : {
                            formatter: '{value} ',
                            
                        },
                        splitNumber: 10,
                        splitLine: {
                            show: false,
                            lineStyle: {
                                type: 'dashed',
                                color: '#A7A7A7'
                            }
                        },
                        axisLine: {
                            lineStyle: {
                                color: '#A7A7A7'
                            }
                        },
                    }
                ],
                series: [
                    {
                        name: currency,
                        type:'line',
                        symbol: 'circel',
                        symbolSize: 1,
                        smooth: true,
                        data: y_data,
                        lineStyle: {
                            // color: 'rgba(34, 166, 148, 1)',
                            width: 2
                        },
                    },
                    {
                        name: 'USDT',
                        type:'line',
                        symbol: 'circel',
                        symbolSize: 1,
                        smooth: true,
                        data: y_data_1,
                        lineStyle: {
                            color: 'rgba(34, 166, 148)',
                            width: 2
                        },
                    },
                ]
            };
            myChart.setOption(option);
            window.onresize = function (){
                assetChartNode.style.width = $('.el-popover').width() + 'px';
                myChart.resize()
            }
        }
    }
}
</script>

<style lang="scss">
    .asset-currency-chart{
        width: 100%;
        height: 300px;
    }

    @media screen and (max-width: 680px) {
        .asset-currency-chart{
            width: 300px;
            height: 300px;
        }
    }
</style>
